let videoElement = null;
// const videoElementSelector = "#video-element";

const setUpVideo = () => {
    // videoElement = document.querySelector(videoElementSelector);
    // if (videoElement) {
    //     console.log("Video Service: setup completed");
    // } else {
    //     console.error("Video Service: video element is not present -- This should not happen.");
    // }
};

const startVideo = () => {
    // if (!videoElement) setUpVideo();
    // videoElement.play().catch((err)=>{
    //     console.log('catched setUpVideo error: didn\'t interact with the document first');
    // });
    // console.log("Video Service: video started");
};

const stopVideo = () => {
    if (videoElement){
        videoElement.pause();
        videoElement.currentTime = 0;
        console.log("Video Service: video stopped");
    }
};

export { startVideo, stopVideo };